import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {CurrentUserAdapter} from '@drl/core/auth/adapters/current-user-adapter.service';
import {ModelEnum} from '@drl/shared/components/cms-list/enums/model.enum';
import * as moment from 'moment';

import {ChatMessage} from '../models';

@Injectable()
export class ChatMessageAdapter implements IAdapter<ChatMessage> {
  constructor(private readonly userAdapter: CurrentUserAdapter) {}

  adaptToModel(resp: any): ChatMessage {
    const message: ChatMessage = new ChatMessage();
    Object.assign(message, resp);
    message.type = 'text';
    if (resp.sender) {
      message.sender = this.userAdapter.adaptToModel(resp.sender);
      message.displayTitle = `${message.sender.fullName}, ${moment(
        message.createdOn,
      ).format('D MMM')}`;
    }
    if (resp.parent) {
      message.parent = this.adaptToModel(resp.parent);
      message.type = 'quote';
    }
    if (resp.contentId) {
      switch (message.contentType) {
        case ModelEnum.GALLERY.toString():
          message.content = {
            icon: 'map-outline',
            url: message.contentUrl,
          };
          break;
        case ModelEnum.CONTENT.toString():
          message.content = {
            icon: 'book-open-outline',
            url: message.contentUrl,
          };
          break;
        default:
          const contentExt = this._getExtension(message.contentUrl);
          if (this._isImage(contentExt)) {
            message.content = {
              icon: '',
              url: message.contentUrl,
              type: `image/${contentExt}`,
            };
          } else if (this._isAudio(contentExt)) {
            message.content = {
              icon: 'headphones-outline',
              url: message.contentUrl,
            };
          } else if (this._isVideo(contentExt)) {
            message.content = {
              icon: 'video-outline',
              url: message.contentUrl,
            };
          } else {
            message.content = {
              icon: 'file-outline',
              url: message.contentUrl,
            };
          }
          break;
      }
      message.type = 'file';
    }
    return message;
  }
  adaptFromModel(data: ChatMessage): any {
    const dataToSend = Object.assign({}, data);
    delete dataToSend.sender;
    delete dataToSend.displayTitle;
    delete dataToSend.content;
    delete dataToSend.type;
    return data;
  }

  private _getExtension(url: string) {
    if(url){
      const urlVal = new URL(url);
      const extensionSplit = urlVal.pathname.split('.');
      const ext = extensionSplit[extensionSplit.length - 1].toLowerCase();
      return ext === 'jpg' ? 'jpeg' : ext;
    }else{
      return '';
    }

  }

  private _isImage(extension: string) {
    return ['jpeg', 'png', 'gif'].includes(extension);
  }

  private _isAudio(extension: string) {
    return [
      '3gp',
      'aa',
      'aax',
      'aiff',
      'au',
      'dct',
      'm4a',
      'm4b',
      'm4p',
      'mp3',
      'wav',
      'wma',
    ].includes(extension);
  }

  private _isVideo(extension: string) {
    return [
      'mkv',
      'flv',
      'avi',
      'mov',
      'wmv',
      'mp4',
      'm4v',
      'mpv',
      'mpg',
      'mpeg',
      'm2v',
      'webm',
    ].includes(extension);
  }
}
